export default function MySQL_CEIL() {
  return (
    <div>
      <h2>MySQL_CEIL</h2>    </div>
  );
}